import { useQuery } from "react-query";
import { getFormationAreas } from "../services/school/formationArea";
import { PagedRequestType } from "../types/PagedResults";
import { Key_FormationAreas } from "../utils/constants";

export const useGetFormationAreasQuery = (data: PagedRequestType, options:any= null) => {
    return useQuery(
        [Key_FormationAreas, JSON.stringify(data)],
        () => getFormationAreas(data),
        options? {...options}:{}
    );
};
